import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { CardContainer } from "@/components/card-container";
import { Button } from "@/components/ui/button";
import { APP_NAME, useTenantDisplayName } from "@/features/branding";

export const TaxOnboardingPage = () => {
  const { t } = useTranslation();
  const clientName = useTenantDisplayName() ?? APP_NAME;

  const navigate = useNavigate();

  function onContinue() {
    navigate("/tax/submit");
  }

  return (
    <div>
      <article>
        <CardContainer>
          <CardContainer.Header>
            <CardContainer.HeaderContent>
              <CardContainer.CardTitle>
                {t("tax_onboarding_irs_title")}
              </CardContainer.CardTitle>
            </CardContainer.HeaderContent>
          </CardContainer.Header>
          <CardContainer.Content>
            <h6 className="text-lg font-semibold">
              {t("tax_onboarding_irs_description")}
            </h6>
            <ul className="list-disc list-inside mt-2">
              <li className="py-2 px-4">
                {t("tax_onboarding_irs_requirements_p1")}
              </li>
              <li className="py-2 px-4">
                {t("tax_onboarding_irs_requirements_p2")}
              </li>
              <li className="py-2 px-4">
                {t("tax_onboarding_irs_requirements_p3")}
              </li>
              <li className="py-2 px-4">
                {t("tax_onboarding_irs_requirements_p4")}
              </li>
              <li className="py-2 px-4">
                {t("tax_onboarding_irs_requirements_p5")}
              </li>
            </ul>
          </CardContainer.Content>
        </CardContainer>
      </article>

      <article>
        <CardContainer>
          <CardContainer.Header>
            <CardContainer.HeaderContent>
              <CardContainer.CardTitle>
                {t("tax_onboarding_security_title")}
              </CardContainer.CardTitle>
            </CardContainer.HeaderContent>
          </CardContainer.Header>
          <CardContainer.Content>
            <p>
              {t("tax_onboarding_security_description_p1", {
                client: clientName,
              })}
            </p>
            <p className="pb-4">
              {t("tax_onboarding_security_description_p2")}
            </p>
          </CardContainer.Content>
        </CardContainer>
      </article>

      <article>
        <CardContainer>
          <CardContainer.Header>
            <CardContainer.HeaderContent>
              <CardContainer.CardTitle>
                {t("tax_onboarding_howItWorks_title")}
              </CardContainer.CardTitle>
            </CardContainer.HeaderContent>
          </CardContainer.Header>
          <CardContainer.Content>
            <ol className="list-decimal list-inside mt-2">
              <li className="py-2 pr-4">
                <span>{t("tax_onboarding_howItWorks_p1Title")}</span>
                <p className="text-sm text-muted-foreground pl-5">
                  {t("tax_onboarding_howItWorks_p1Description")}
                </p>
              </li>
              <li className="py-2 pr-4">
                <span>{t("tax_onboarding_howItWorks_p2Title")}</span>
                <p className="text-sm text-muted-foreground pl-5">
                  {t("tax_onboarding_howItWorks_p2Description")}
                </p>
              </li>
              <li className="py-2 pr-4">
                <span>{t("tax_onboarding_howItWorks_p3Title")}</span>
                <p className="text-sm text-muted-foreground pl-5">
                  {t("tax_onboarding_howItWorks_p3Description")}
                </p>
              </li>
              <li className="py-2 pr-4">
                <span>{t("tax_onboarding_howItWorks_p4Title")}</span>
                <p className="text-sm text-muted-foreground pl-5">
                  {t("tax_onboarding_howItWorks_p4Description")}
                </p>
              </li>
            </ol>
          </CardContainer.Content>
        </CardContainer>
      </article>

      <section>
        <div className="flex justify-end mt-4">
          <Button onClick={onContinue}>{t("continue_text")}</Button>
        </div>
      </section>
    </div>
  );
};
